import { Component, HostListener, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { GlobalobjectsService } from "../../globalobjects.service";
import { LoginService } from "../loginc/login.service";
import { ToastrService } from "ngx-toastr";
import { LogoutService } from "src/app/shared/services/logout.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-select-customer",
  templateUrl: "./select-customer.component.html",
  styleUrls: ["./select-customer.component.scss"],
})
export class SelectCustomerComponent implements OnInit {
  
  // ==================== PROPERTIES ====================
  
  // Existing Properties
  countryName: any;
  msg: string;
  loginError: string;
  companylist: any;
  logoPath: string;
  customersList: any;
  selectedCustomer: any;
  PreLoader: boolean = false;
  cname: any;
  bgImageUrl: string = "../../../assets/images/Al-Safa-Banner-Home.jpg";
  settings: any;
  isDropdownOpen = false;
  IsSalesRep: boolean = false;

  // New Properties for Awaiting Orders
  awaitingOrders: any[] = [];
  selectedOrderForView: any = null;
  @ViewChild('orderDetailsModal') orderDetailsModal: any;

  // ==================== CONSTRUCTOR ====================
  
  constructor(
    private toastrService: ToastrService,
    private route: Router,
    public Loginservice: LoginService,
    public Globalobjects: GlobalobjectsService,
    public router: Router,
    public logoutservices: LogoutService,
    private modalService: NgbModal
  ) {
    this.countryName = localStorage.getItem("country");
  }

  // ==================== LIFECYCLE HOOKS ====================
  
  ngOnInit(): void {
    const settingString1 = localStorage.getItem('setting') as string;
    if (settingString1 != 'undefined' && settingString1 != null) {
      this.settings = JSON.parse(settingString1);
    }

    this.bgImageUrl = this.Globalobjects.BUSINESSINFOIMAGEURL + this.settings.path_BackGroundImage2;

    if (localStorage.getItem("isSalesRep") !== "true") {
      this.router.navigate(["/company"]);
    }

    const settingString = localStorage.getItem("setting") as string;
    if (settingString != "undefined" && settingString != null) {
      let setting = JSON.parse(settingString);
      this.logoPath = this.Globalobjects.BUSINESSINFOIMAGEURL + setting.logo;
    } else {
      this.logoPath = "assets/images/placeholder-logo-2.png";
    }

    localStorage.removeItem("cartItems");
    localStorage.removeItem("editmode");
    localStorage.removeItem("editOrderId");
    localStorage.removeItem("draftOrder");

    this.customersList = JSON.parse(localStorage.getItem("SalesRepCustomersList") as string);
    if (this.customersList) {
  this.customersList.sort((a: any, b: any) =>
    a.displayName.localeCompare(b.displayName)
  );
}
    this.cname = this.capitalizeName(localStorage.getItem('cname'));

    // ✅ Load Awaiting Orders on Init
    this.loadAwaitingOrders();
  }

  // ==================== EXISTING METHODS ====================
  
  capitalizeName(name: string): string {
    return name?.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
  }

  @HostListener("document:click", ["$event"])
  closeDropdown(event: Event) {
    this.isDropdownOpen = false;
  }

  toggleDropdown(event: Event) {
    this.isDropdownOpen = !this.isDropdownOpen;
    event.stopPropagation();
  }

  logout() {
    this.logoutservices.logout();
  }

  selectCountry(customerId: any) {
    this.selectedCustomer = this.customersList.find(
      (customer: any) => customer.id == customerId
    );
    console.log("Selected Customer:", this.selectedCustomer);
  }

  onSubmit() {
    console.log("Selected Customer: " + this.selectedCustomer);

    if (!this.selectedCustomer) {
      alert("Please Select Customer");
      return;
    }

    localStorage.setItem("customerNumber", this.selectedCustomer.number);

    const itemdata = {
      countryList_Id: this.countryName,
      customerNumber: this.selectedCustomer.number,
    };

    this.PreLoader = true;
    this.fetchItems(itemdata);
  }

  fetchItems(customerData: any) {
    this.Loginservice.GetItmes(customerData).subscribe(
      (itemsResponse: any) => {
        localStorage["loginresponse"] = JSON.stringify(itemsResponse);
        console.log("Items API Response:", itemsResponse);

        localStorage.setItem("customercredit", itemsResponse.customerInfo.creditLimit);
        localStorage.setItem("customer_Id", itemsResponse.customerInfo.customer_Id);
        localStorage.setItem("customerbalance", itemsResponse.customerInfo.balanceDue);
        localStorage.setItem("pricegroup", itemsResponse.customerInfo.customerPriceGroup);
        localStorage.setItem("shippingcode", itemsResponse.customerInfo.shipToCode);
        localStorage.setItem("selectedCustomerName", itemsResponse.customerInfo.customerName);

        this.getPromotionDetails(itemsResponse);
      },
      (error) => {
        console.error("Error fetching items:", error);
        this.PreLoader = false;
        this.toastrService.error("Error loading items. Please try again.");
      }
    );
  }

  getPromotionDetails(itemsResponse: any) {
    const data = {
      countryList_Id: localStorage.getItem("country"),
      customerNumber: this.selectedCustomer.number,
      customerPriceGroup: localStorage.getItem("pricegroup"),
    };

    this.Loginservice.getPromotionDetails(data).subscribe(
      (promoResponse: any) => {
        console.log("Promotion Details API Response:", promoResponse);
        localStorage.setItem("promotiondata", JSON.stringify(promoResponse.data));
        this.mapAndStoreData(itemsResponse, promoResponse);
      },
      (error) => {
        console.error("Error fetching promotions:", error);
        this.PreLoader = false;
      }
    );
  }

  mapAndStoreData(itemsResponse: any, promoResponse: any) {
    const apiData = itemsResponse.itemInfo;
    const promotionData = promoResponse.data;

    for (let i = 0; i < apiData.length; i++) {
      apiData[i].Variants = [
        {
          variant_id: 101,
          id: 1,
          sku: "sku1",
          size: "s",
          color: "yellow",
          image_id: 111,
        },
      ];

      apiData[i].Images = [
        {
          image_id: 111,
          id: 1,
          alt: "yellow",
          src: "assets/images/product/fashion/39.jpg",
          variant_id: [101, 104],
        },
        {
          image_id: 112,
          id: 1,
          alt: "white",
          src: "assets/images/product/fashion/6.jpg",
          variant_id: [102, 105],
        },
      ];
    }

    promotionData.forEach((promotion: any) => {
      if (promotion.isActive) {
        const currentDate = new Date();
        const startDate = new Date(promotion.date_Start);
        const endDate = new Date(promotion.date_End);

        if (currentDate >= startDate && currentDate <= endDate) {
          if (promotion.isApply_MinQty) {
            promotion.promotion_Items.forEach((promoItem: any) => {
              if (promoItem.isInput) {
                apiData.forEach((item: any) => {
                  if (promoItem.itemNumber === item.itemNumber && promoItem.isInput) {
                    item.promoProduct = true;
                    item.promotionDescription = promotion.promotionDescription;
                  }
                });
              }
            });
          }
        }
      }
    });

    const mappedData = apiData.map((item: any) => {
      return {
        id: item.itemNumber,
        title: item.itemName,
        description: "Our Products",
        type: item.itemCategoryCode,
        moq: item.mininumOrderQuantity,
        mo: item.multipleOff,
        brand: "",
        collection: ["new products"],
        category: "",
        price: item.unitPrice,
        sale: item.isDiscount,
        discount: item.discountPercent,
        stock: 10000000,
        barcode: item.itemUPC,
        commonItemNo: item.commonItemNo ? item.commonItemNo : item.itemNumber,
        new: false,
        sortingno: item.portalSortingNo,
        categorySortingNo: item.categorySortingNo,
        pricepercase:
          item.unitPrice && item.noOfRetailsInACase
            ? item.unitPrice / item.noOfRetailsInACase
            : 0,
        isPriceGroup: item.isPriceGroup,
        promoProduct: item.promoProduct || false,
        promotionDescription: item.promotionDescription || "",
        tags: [],
        variants: item.Variants.map((variant: any) => {
          return {
            variant_id: variant.variant_id,
            id: variant.id,
            sku: variant.sku,
            size: variant.size,
            color: variant.color,
            image_id: variant.image_id,
          };
        }),
        images: item.Images.map((image: any) => {
          return {
            image_id: image.image_id,
            id: image.id,
            alt: "Item Code: " + item.itemNumber,
            src:
              this.countryName + "_" + item.itemNumber + ".png" &&
              this.countryName + "_" + item.itemNumber + ".png".trim() !== ""
                ? this.countryName + "_" + item.itemNumber + ".png"
                : "placeholder.jpg",
            variant_id: image.variant_id,
          };
        }),
      };
    });

    this.Globalobjects.productdata = mappedData;
    localStorage["rproducts"] = JSON.stringify(mappedData);

    this.PreLoader = false;
    this.route.navigate(["/index"]).then(() => {
      window.location.reload();
    });
  }

  // ==================== NEW METHODS - AWAITING ORDERS ====================

  /**
   * Load awaiting approval orders from API
   */
  loadAwaitingOrders(): void {
    try {
      const data = {
        salesRepCode: localStorage.getItem("salesRepCode"),
        countryList_Id: localStorage.getItem("country"),
        orderStatus: "processing",
      };

      console.log("Fetching awaiting orders with data:", data);

      this.Loginservice.getsalesrepordersdata(data).subscribe(
        (response: any) => {
          console.log("✅ Sales Rep Orders Data:", response);

          if (response && response.data && Array.isArray(response.data)) {
            this.awaitingOrders = response.data;
            if (this.awaitingOrders) {
  this.awaitingOrders.sort((a: any, b: any) =>
    a.customerName.localeCompare(b.customerName)
  );
}
            localStorage.setItem("SalesRepOrdersData", JSON.stringify(response.data));
            console.log(`✅ Loaded ${this.awaitingOrders.length} awaiting orders`);
          } else {
            console.warn("⚠️ No orders found in response");
            this.awaitingOrders = [];
          }
        },
        (error) => {
          console.error("❌ Error loading awaiting orders:", error);
          this.awaitingOrders = [];
          this.toastrService.error("Error loading orders. Please refresh the page.");
        }
      );
    } catch (error) {
      console.error("❌ Exception in loadAwaitingOrders:", error);
      this.awaitingOrders = [];
    }
  }

  /**
   * View order details - set selected order and open modal
   */

  /**
   * View order details - set selected order and open modal
   */
  viewOrderDetails(order: any): void {
    try {
      this.selectedOrderForView = order;
      console.log("📋 Selected Order for View:", order);
      
      // Open modal using NgbModal
      this.modalService.open(this.orderDetailsModal, { size: 'lg' });
    } catch (error) {
      console.error("❌ Error viewing order details:", error);
      this.toastrService.error("Error loading order details");
    }
  }

  /**
   * Refresh awaiting orders (can be called manually)
   */
  refreshAwaitingOrders(): void {
    console.log("🔄 Refreshing awaiting orders...");
    this.loadAwaitingOrders();
  }
}